import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { earnService } from "../../Api/earnService";

const initialState = {
  allEarnCampaigns: [],
  bonusTierInfo: [],
  earnPlanHistory: [],
  planDetails: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
};

export const getAllEarnCampaign = createAsyncThunk(
  "get/all-earn-campaigns",
  async (_, thunkAPI) => {
    try {
      return await earnService.getAllEarnCampaign();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getBonusTierInfo = createAsyncThunk(
  "get/bonus-tier-info",
  async (_, thunkAPI) => {
    try {
      return await earnService.getBonusTierInfo();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const addEarnPlan = createAsyncThunk(
  "add/earnPlan",
  async (data, thunkAPI) => {
    try {
      return await earnService.addEarnPlan(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
export const getEarnPlanHistory = createAsyncThunk(
  "get/earn-plan-history",
  async (data, thunkAPI) => {
    try {
      return await earnService.getEarnPlanHistory(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getPlanDetails = createAsyncThunk(
  "get/earn-plan-details",
  async (data, thunkAPI) => {
    try {
      return await earnService.getPlanDetails(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const terminateEarnPlan = createAsyncThunk(
  "terminate/earnPlan",
  async (data, thunkAPI) => {
    try {
      return await earnService.terminateEarnPlan(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const earnSlice = createSlice({
  name: "earn",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllEarnCampaign.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getAllEarnCampaign.fulfilled, (state, action) => {
        state.allEarnCampaigns = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getAllEarnCampaign.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(addEarnPlan.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(addEarnPlan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(addEarnPlan.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getBonusTierInfo.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getBonusTierInfo.fulfilled, (state, action) => {
        state.bonusTierInfo = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getBonusTierInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getEarnPlanHistory.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getEarnPlanHistory.fulfilled, (state, action) => {
        state.earnPlanHistory = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getEarnPlanHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getPlanDetails.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getPlanDetails.fulfilled, (state, action) => {
        state.planDetails = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getPlanDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })

      .addCase(terminateEarnPlan.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(terminateEarnPlan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(terminateEarnPlan.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      });
  },
});

export default earnSlice.reducer;
